export interface RuntimePublicConfig {
    apiUrl: string;
    baseFileUrl: string;
    chatAiUrl: string;
    originUrl: string;
    publicPath: string;
    tenantId: string;
    userNodeEnv: string;
    wsUrl: string;
    wxAppId: string;
}

/** 环境配置字段与旧 Pinia runtimeConfig.public 一一对应。 */
export const runtimePublicConfig: RuntimePublicConfig = {
    apiUrl: import.meta.env.VITE_API_URL || "",
    baseFileUrl: import.meta.env.VITE_BASE_FILE_URL || "",
    chatAiUrl: import.meta.env.VITE_AI_URL || "",
    originUrl: import.meta.env.VITE_ORIGIN_URL || "",
    publicPath: import.meta.env.VITE_PUBLIC_PATH || "",
    tenantId: import.meta.env.VITE_TENANT_ID || "",
    userNodeEnv: import.meta.env.VITE_USER_NODE_ENV || "",
    wsUrl: import.meta.env.VITE_WS_URL || "",
    wxAppId: import.meta.env.VITE_WX_APP_ID || ""
};

export const defaultTheme = {
    systemName: "链云砂石",
    systemAbbreviation: "链云",
    systemHeaderSlogan: "产业新质生产力服务商",
    aiName: "链小云",
    serviceTel: "400-0707-798",
    themeColor: "#FFDB5C",
    copyright: `Copyright © ${new Date().getFullYear()} 志豪链云科技有限公司 All Rights Reserved.`,
    icpFilings: "鄂ICP备2024034058号-1",
    internetFilings: ""
};

/** 当前 Vue Tenant.init 固定使用默认主题；React 保持相同初始化结果。 */
export async function initializeTenant() {
    const themeColor = defaultTheme.themeColor;
    document.documentElement.style.setProperty("--el-color-theme", themeColor);
    document.documentElement.style.setProperty("--el-color-button-text-color", "#333333");
    document.title = defaultTheme.systemName || import.meta.env.VITE_GLOB_APP_TITLE;
    return defaultTheme;
}
